import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { KPI } from '../../../../@core/api';
import { ConfigService, ReportsService } from '../../../../@core/utils';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-site-overview-reports',
    templateUrl: './site-overview-reports.component.html',
    styleUrls: ['./site-overview-reports.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    NgStyle,
    
],
})
export class SiteOverviewReportsComponent implements OnInit, OnDestroy {

  public reportTemplates: KPI.ReportTemplate[] = [];
  public reportsColor: string = "#ffffff";
  public reportsFontsColor: string = "#798590";

  constructor(
    private reportsService: ReportsService,
    private cdRef: ChangeDetectorRef,
    private configService: ConfigService,
  ) { }

  private subscriptions: Subscription[] = [];
  @Input() public perimeter: KPI.Perimeter;
  public reportLoading: boolean = false;

  ngOnInit() {
    this.subscriptions.push(
      this.configService.customerConfig$.subscribe(config => {
        if (config.reports_color) {
          this.reportsColor = config.reports_color
        };
        if (config.reports_fonts_color) {
          this.reportsFontsColor = config.reports_fonts_color
        }
      }),
      this.reportsService.isAnyReportDownloading$.subscribe((reportLoading) => {
        this.reportLoading = reportLoading;
        this.cdRef.detectChanges();
      }),
      this.reportsService.userReportTemplates$.subscribe((templates) => {
        this.reportTemplates = [];
        templates.forEach(template => {
          if (template.report_type_ref === "mono_site") {
            this.reportTemplates.push(template);
          }
        });
        this.cdRef.detectChanges();
      })
    );
  }

  public showPerimeterReportTemplateDialog(template: KPI.ReportTemplate): void {
    this.reportsService.showPerimeterReportTemplateDialog(template, this.perimeter);
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
